Namespace('Monitoring.Reports.SocialListening')

class Monitoring.Reports.SocialListening.ReportView extends Backbone.View
	className: 'social-listening-report'

	initialize: (@options = {}) ->
    # just set @options

  render: ->
		@renderHeader()
		return this
	
	renderHeader: =>
		header = new Monitoring.Reports.SocialListening.HeaderView(@options)
		header.render()
		@$el.html(header.el)